export default __webpack_public_path__ + "static/media/Bengaluru-college-Karnataka.8c68df97.jpg";